export default "__VITE_ASSET__BM0xaerr__"